import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./SplitLayout.css";

export default function SplitLayout({
  right,
  left,
  className,
  leftClassName,
  rightClassName,
}) {
  //both divs are needed even if empty for flexbox to work
  return (
    <div className={classNames(styles.root, className)}>
      <div className={leftClassName}>{left}</div>
      <div className={rightClassName}>{right}</div>
    </div>
  );
}

SplitLayout.propTypes = {
  right: PropTypes.node,
  left: PropTypes.node,
  className: PropTypes.string,
  leftClassName: PropTypes.string,
  rightClassName: PropTypes.string,
};
